import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navigationData } from '../../data/mock';

// IATA Logo URL
const IATA_LOGO = "https://customer-assets.emergentagent.com/job_github-tester/artifacts/2n27nzsw_IATAlogo.svg";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Scroll handler
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <nav className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a
            href="#"
            className="text-xl sm:text-2xl font-light tracking-[0.15em] text-[#c9a96e] uppercase"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {navigationData.logo}
          </a>

          {/* Desktop Navigation */}
          <ul className="hidden lg:flex items-center gap-8">
            {navigationData.links.map((link) => (
              <li key={link.label}>
                <button
                  onClick={() => scrollToSection(link.href)}
                  className="text-[13px] font-light tracking-[0.1em] text-white/80 hover:text-[#c9a96e] transition-colors duration-300 uppercase"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          {/* IATA Association - Desktop - Professional Badge Style */}
          <div className="hidden lg:flex items-center gap-3 border border-white/20 rounded px-4 py-2 bg-white/5 backdrop-blur-sm">
            <img 
              src={IATA_LOGO} 
              alt="IATA" 
              className="h-8 w-auto"
              style={{ background: 'transparent' }}
            />
            <div className="flex flex-col">
              <span 
                className="text-[13px] font-light tracking-[0.1em] text-white/90 uppercase"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Club Travel
              </span>
              <span 
                className="text-[11px] text-[#c9a96e] tracking-wider font-medium"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                IATA 772 02182
              </span>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-white"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#0a1628]/98 backdrop-blur-md border-t border-white/10 py-6">
            <ul className="flex flex-col gap-4">
              {navigationData.links.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-[13px] font-light tracking-[0.1em] text-white/80 uppercase w-full text-left py-2"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              
              {/* IATA Association - Mobile - Badge Style */}
              <li className="border-t border-white/10 pt-4 mt-2">
                <div className="flex items-center gap-3 border border-white/20 rounded px-3 py-2 bg-white/5 w-fit">
                  <img 
                    src={IATA_LOGO} 
                    alt="IATA" 
                    className="h-6 w-auto"
                    style={{ background: 'transparent' }}
                  />
                  <div className="flex flex-col">
                    <span 
                      className="text-[11px] font-light tracking-[0.1em] text-white/90 uppercase"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      Club Travel
                    </span>
                    <span 
                      className="text-[10px] text-[#c9a96e] tracking-wider font-medium"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      IATA 772 02182
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
